/* libs/oyan-ui/src/lib/components/mat-menu-list/mat-menu-list.component.scss */
/*# sourceMappingURL=mat-menu-list.component.css.map */
